<template>
  <div class="about">
    <h1>夢占い辞典ゆめみんとは？</h1>
    <img src="https://dream.ameneko.com/ogpImage.jpeg" alt="ゆめみんアイキャッチ">
    <div class="main_text">
      <h2>昨夜の夢の意味を知りたい全ての人へ</h2>
      <p>「夢占い辞典ゆめみん」は、その名の通り、<span style="font-weight:bold">夢占い辞典・夢診断・夢解釈のウェブサイトです。</span></p>
      <p>誰にでも、昨夜見た夢の意味がどうしても気になることがあります。</p>
      <p>不思議な夢、面白い夢、悲しい夢、不気味な夢、怖い夢…。</p>
      <p>これらの夢は、あなたの奥底に渦巻く潜在意識から掬い上げられたメッセージかもしれません。</p>
      <p>夢占い辞典ゆめみんでは、それら夢のメッセージを読み解くお手伝いをしたいと思っています。</p>
      <h2>夢の中で印象に残ったキーワードを検索して夢の意味を知る</h2>
      <p style="font-weight:bold">「夢占い辞典ゆめみん」では、夢の中で気になったキーワードを検索することで、そのキーワードが象徴する意味を知ることができます。</p>
      <p>人間は無意識のうちに、あらゆる対象にラベリングを行っています。</p>
      <p>簡単に言えば、「悪魔」は、悪いもの、不吉なものだと常識的に理解しています。（「悪魔」を幸せをもたらす存在だとは思う人は少ないはずです。）</p>
      <p style="font-weight:bold;">こうした象徴（シンボル）の意味を捉え、解釈するのが「夢占い・夢診断・夢解釈」と言えます。</p>
      <p>例えば、夢の中で特に印象に残った人物や対象に、どのような印象を抱いたか、どのような話になったかなど、夢のシチュエーションと象徴（シンボル）からあなたの潜在意識のメッセージを読み解くのです。</p>
      <p>ただし、自分の中での対象のイメージに強く影響を受ける夢占いの性質上、人によって物事の捉え方は微妙に変わってくるため、自分である程度解釈を加える必要があることも事実です。</p>
      <p>例えば、「りんご」が好きな人が夢で見る「りんご」と、嫌いな人が夢で見る「りんご」では、印象が違うのは当然です。</p>
      <p>ですので、<span style="font-weight:bold;">夢占いでは一般的な象徴（シンボル）について捉えることは得意ですが、それ以上の深い洞察については自分自身である程度判断する必要があります。夢占いの内容を決して鵜呑みにしないように注意してください。</span></p>
      <p>ちなみに、夢占いは、慣れれば慣れるほど、より明確に意味を把握できるようになるので、気になる夢があったら継続的に調べることをオススメします。</p>
      <h2>現実と夢では全く逆の意味を持つ場合もある</h2>
      <p>現実の世界では喜ばしいとされることでも、夢の中で登場すると不吉であったり悪い意味を持つキーワードもあります。</p>
      <p>一般的に有名なのは「結婚の夢」です。現実の世界では「結婚」は祝いの象徴ですが、夢の中では凶夢である場合が多いとされます。</p>
      <p>逆に、現実ではマイナスのことが、夢ではプラスであることもありますので、思い込みをしないよう注意が必要です。</p>
      <h2>参考文献</h2>
      <p>当サイトでは、以下の書籍、サイトを参考にさせていただいております。</p>
      <li>夢占い入門（小林三剛）</li>
      <li>夢判断（外林大作）</li>
      <li>夢判断（フロイト）</li>
      <li>夢と夢解釈（フロイト）</li>
      <li>夢分析（ユング）</li>
      <li>細密 夢占い事典 (elfin books series)</li>
      <li>ズバリ的中夢占い辞典（武藤安隆）</li>
      <li>イメージシンボル事典（アト・ド・フリース）</li>
      <li>シンボル事典（北星堂）</li>
      <li>図説 世界シンボル事典（ハンス・ビーダーマン）</li>
      <li>西洋シンボル事典（G.ハインツ＝モーア）</li>
      <li>花のシンボル事典（杉原梨江）</li>
      <li>美術シンボル事典（ヒルデガルト・クレッチマー）</li>
      <li>世界シンボル大事典（大修館書店）</li>
      <li><a href="http://www.dreammoods.com/">dreammoods</a></li>
      <li><a href="https://petrix.com/dreams/">DREAM DICTIONARY: THE MEANING OF DREAMS</a></li>
    </div>
  </div>

</template>

<script>
    export default {
    }
</script>

<style scoped>
.about{
  max-width: 800px;
  margin: auto;
}
h1{
  font-size:1.2em;
  font-weight: bold;
  text-align: center;
  padding-bottom: 16px; 
}
h2{
  font-size:1.1em;
  font-weight: bold;
  padding-top: 16px;
  padding-bottom: 16px; 
}
hr{
  margin: 10px;
}
.main_text{
  padding: 10px; 
}
</style>
